module.exports = __webpack_public_path__ + "img/pride_logo_white.b0f16457.png";